import React from 'react';

const DonutChart = ({ data, colors, width = 120, height = 120, strokeWidth = 13, innerCount }) => {
    const total = data.reduce((sum, val) => sum + val, 0);
    let cumulative = 0;

    const center = width / 2;
    const radius = (width - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    // Check if all values are 0
    const allValuesZero = data.every(value => value === 0);

    return (
        <svg width={width} height={height} style={{ position: 'relative' }}>
            {innerCount && (
                <text x={center} y={center} textAnchor="middle" dominantBaseline="middle" fontSize="20px" fill="var(--Brand-Primary)">
                    {innerCount}
                </text>
            )}
            {data.map((value, i) => {
                const dashArray = `${(value / total) * circumference} ${circumference}`;
                const dashOffset = (-cumulative / total) * circumference;
                cumulative += value;
                return (
                    <circle
                        key={i}
                        r={radius}
                        cx={center}
                        cy={center}
                        fill="none"
                        stroke={allValuesZero ? '#808080' : colors[i % colors.length]}
                        strokeWidth={strokeWidth}
                        strokeDasharray={dashArray}
                        strokeDashoffset={dashOffset}
                        style={{ transition: 'stroke-dasharray 0.3s' }}
                    />
                );
            })}
        </svg>
    );
};

export default DonutChart;
